import React from "react";
import { ArrowLeft } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import PilotBanner from "@/modules/racket_lab_admin/PilotBanner";
import RLNavSidebar from "@/modules/racket_lab_admin/RLNavSidebar";
import LegacyRunReportCard from "@/modules/racket_lab_admin/LegacyRunReportCard";
import useAdminApi from "@/hooks/useAdminApi";
import { useRacketLabAdminT } from "@/i18n/racketLabAdminI18n";

const RLAdminOpsLegacyRunReport = () => {
  const t = useRacketLabAdminT();
  const { runId } = useParams();
  const { data, loading, error } = useAdminApi(
    `/admin/racket-lab/_ops/legacy-memberships-run-report?run_id=${encodeURIComponent(runId || "")}`,
    { skip: !runId },
  );
  return (
    <div data-testid="rl-admin-ops-legacy-run-report-page" className="flex flex-col gap-4">
      <PilotBanner />
      <RLNavSidebar />
      <Link to="/admin/racket-lab/ops/legacy" className="inline-flex w-fit items-center gap-1 text-xs text-slate-600 hover:text-slate-900"><ArrowLeft className="w-3.5 h-3.5" /> {t("ops.legacy.run_report_page.back")}</Link>
      <header><h1 className="text-xl font-semibold text-slate-900">{t("ops.legacy.run_report_page.page_title")}</h1></header>
      {loading && <div className="rounded-md border border-slate-200 bg-white p-4 text-sm text-slate-500">{t("ops.legacy.run_report_page.loading")}</div>}
      {error && <div data-testid="rl-ops-legacy-run-report-error" className="rounded-md border border-rose-200 bg-rose-50 p-3 text-xs text-rose-800">{t("ops.common.error_prefix")} {error.status || ""}: {error.detail || t("ops.common.error_unknown")}</div>}
      {data && <LegacyRunReportCard data={data} dataTestId="rl-ops-legacy-run-report-card" />}
    </div>
  );
};

export default RLAdminOpsLegacyRunReport;
